export const SECRET_SLUG = 'secret-group-slug-used-for-editor';
